import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
});

export const setAdminToken = (token) => {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
    try { localStorage.setItem("ncl_admin_token", token); } catch (_) {}
  } else {
    delete api.defaults.headers.common.Authorization;
    try { localStorage.removeItem("ncl_admin_token"); } catch (_) {}
  }
};

export const loadAdminToken = () => {
  try {
    const t = localStorage.getItem("ncl_admin_token");
    if (t) {
      api.defaults.headers.common.Authorization = `Bearer ${t}`;
      return t;
    }
  } catch (_) {}
  return null;
};
